/**
 * Color Constants
 * Shared color schemes, status colors, and UI color palettes
 * @module @shared/constants
 */

/**
 * Status and indicator colors (Tailwind color classes)
 */
export const STATUS_COLORS = {
  SUCCESS: {
    bg: 'bg-tone-positive-solid/10',
    border: 'border-tone-positive-solid/30',
    text: 'text-tone-positive',
    icon: 'bg-tone-positive-solid',
  },
  ERROR: {
    bg: 'bg-tone-negative-solid/10',
    border: 'border-tone-negative-solid/30',
    text: 'text-tone-negative-on-tint',
    icon: 'bg-tone-negative-solid',
  },
  WARNING: {
    bg: 'bg-tone-caution-solid/10',
    border: 'border-tone-caution-solid/30',
    text: 'text-tone-caution',
    icon: 'bg-tone-caution-solid',
  },
  INFO: {
    bg: 'bg-primary/10',
    border: 'border-primary/30',
    text: 'text-primary',
  },
} as const;

/**
 * Performance/Score level colors (HSL format for dynamic theming)
 */
export const PERFORMANCE_COLORS = {
  HIGH: {
    hsl: 'hsl(var(--tone-score-high-hsl))',
    class: 'text-tone-positive',
  },
  MEDIUM: {
    hsl: 'hsl(var(--tone-score-mid-hsl))',
    class: 'text-tone-caution',
  },
  LOW: {
    hsl: 'hsl(var(--tone-score-low-hsl))',
    class: 'text-tone-negative',
  },
} as const;

/**
 * Difficulty level colors (Tailwind badge styles)
 */
export const DIFFICULTY_COLORS = {
  EASY: {
    bg: 'bg-tone-positive-solid/10',
    text: 'text-tone-positive',
  },
  MEDIUM: {
    bg: 'bg-tone-caution-solid/10',
    text: 'text-tone-caution',
  },
  HARD: {
    bg: 'bg-tone-negative-solid/10',
    text: 'text-tone-negative-on-tint',
  },
} as const;
